export const UploadStatus = {
  Waiting: 'waiting',
  Uploading: 'uploading',
  Processing: 'processing',
  Succeeded: 'succeeded',
  Failed: 'failed'
};